exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3tJiY {\n  margin-top: 0 !important;\n  padding: 10px !important;\n}\n._3tJiY {\n  cursor: pointer;\n}\n._3tJiY a,\n._3tJiY a:hover,\n._3tJiY a:active,\n._3tJiY a:focus {\n  text-decoration: none;\n}\n._3tJiY ._1WL3t {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  padding-top: 5px;\n  padding-right: 10px;\n}\n", ""]);

// Exports
exports.locals = {
	"list": "_3tJiY",
	"remark": "_1WL3t"
};